'use client';

import { useEffect, useState } from 'react';

import { useAnalyticsContext } from '@lib/segment/useAnalyticsContext';

export const SegmentGlobalOptions = (): JSX.Element => {
  const [isHeaderAvailable, setIsHeaderAvailable] = useState(false);
  const { pageViewId, pageName } = useAnalyticsContext();

  useEffect(() => {
    const timeout = setInterval(() => {
      if (typeof window?.nerdwallet?.ui?.setHeaderProps === 'function') {
        setIsHeaderAvailable(true);
        clearInterval(timeout);
      }
    }, 100);
  }, []);

  useEffect(() => {
    if (!isHeaderAvailable) return;

    window.nerdwallet?.ui?.setHeaderProps({
      segmentTrackingAttributes: {
        driverPageViewId: pageViewId,
        driverPageName: pageName,
      },
    });
  }, [isHeaderAvailable, pageName, pageViewId]);

  return null;
};
